import { parseUtc } from '@/cloud/models/device-status';

/** "just now", "4 min ago", "3 h ago", "2 d ago" — compact for the narrow drawer. */
export function timeAgo(value: string | null | undefined, now = Date.now()): string | null {
    const t = parseUtc(value ?? null);
    if (t === null) return null;
    const seconds = Math.max(0, Math.round((now - t) / 1000));
    if (seconds < 45) return 'just now';
    const minutes = Math.round(seconds / 60);
    if (minutes < 60) return `${minutes} min ago`;
    const hours = Math.round(minutes / 60);
    if (hours < 48) return `${hours} h ago`;
    return `${Math.round(hours / 24)} d ago`;
}

/** mm:ss for a countdown. */
export function clock(ms: number): string {
    const total = Math.max(0, Math.ceil(ms / 1000));
    const m = Math.floor(total / 60);
    const s = total % 60;
    return `${m}:${s.toString().padStart(2, '0')}`;
}

/** Turns a tool name such as `search_device_logs` into "Search device logs". */
export function toolLabel(name: string | null | undefined): string {
    if (!name) return '';
    const words = name.replace(/_/g, ' ').trim();
    return words.charAt(0).toUpperCase() + words.slice(1);
}

/** PrimeIcon for a tool, by what it reads. */
export function toolIcon(name: string | null | undefined): string {
    const n = name ?? '';
    if (n.includes('log') || n.includes('problem') || n.includes('triage')) return 'pi pi-list';
    if (n.includes('config') || n.includes('property')) return 'pi pi-sliders-h';
    if (n.includes('feedback') || n.includes('room')) return 'pi pi-star';
    if (n.includes('location')) return 'pi pi-map-marker';
    if (n.includes('package') || n.includes('software') || n.includes('firmware') || n.includes('deploy')) return 'pi pi-box';
    if (n.includes('metric') || n.includes('hotspot') || n.includes('utilisation')) return 'pi pi-chart-line';
    if (n.includes('issue')) return 'pi pi-github';
    if (n.includes('platform') || n.includes('tenant') || n.includes('namespace')) return 'pi pi-globe';
    if (n.includes('action')) return 'pi pi-bolt';
    return 'pi pi-server';
}
